module.exports = __webpack_public_path__ + "static/img/8.4415c15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/8.png
// module id = Bepi
// module chunks = 0